import React ,{useState,useEffect} from 'react'
import Loader from 'react-loader-spinner';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer ,Tooltip} from 'recharts'
import { numberWithCommas } from '../../service/utilService';

const COLORS = ['#FDA629','#AA4548', '#DB3236', '#FFE038', '#B5B5B5', '#dc3545', '#198754', '#0dcaf0', '#6c757d','aqua', 'blue', 'fuchsia', 'gray', 'green', 
'lime', 'maroon', 'navy', 'olive', 'orange', 'purple', 'red', 
'silver', 'teal', 'white', 'yellow'];

export default function ConcessionaireDashboardChart(props) {
    const{chartHeader, cartHeaderCount,cartHeaderValue, data,showRupee, nameKey, dataKey,loader,fractionalDigit=0} = props;
    const [filterData,setFilterData] = useState([]);

    useEffect(() => {
      if(data?.length>0){
      const filteredData = data?.filter(e=> ((e[dataKey]/cartHeaderCount)*100)>=1)
      filteredData.sort((a,b)=> b[dataKey]-a[dataKey]);
      setFilterData(filteredData)
      }
    }, [data])
    
    const CustomTooltip = ({ active, payload, label}) => {
        if (active) {
          let  percentage = (payload[0].value/cartHeaderCount)*100;
            return (
                <div className="custom-tooltip">
                    <p className="label">
                        Plaza ID : {!['rejectionReason','entry_toll_plaza_id'  ].includes(nameKey) ?'':''}{payload[0].name} <br/>
                        {nameKey === "entry_toll_plaza_id"
                        ? <>Count : {numberWithCommas(payload[0].value,fractionalDigit)} <br/>
                            Value : {numberWithCommas(payload[0].payload.sumAmount,fractionalDigit)} {showRupee && <>&#8377;</>}  </> 
                        : <>Traffic : {showRupee && <>&#8377;</>}{numberWithCommas(payload[0].value,fractionalDigit)} ({percentage.toFixed(dataKey == "sumAmount" ? 2 : 0)}%)  </> 
                        }
                     </p>
                </div>
            );
        }
        return null;
    };
    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({cx, cy, midAngle, innerRadius, outerRadius, percent}) => {
	const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
	const x = cx + radius * Math.cos(-midAngle * RADIAN);
	const y = cy + radius * Math.sin(-midAngle * RADIAN);

	return (
		<text  x={x} y={y} fill="white" textAnchor={ 'middle' } dominantBaseline="central">
    	{`${(percent * 100).toFixed(0)}%`}
		</text>
	);
};

  return (
     <div className="tarnsaction-chart" style={{height:500}}>
        <p className={  nameKey==="entry_toll_plaza_id" ? "phase5-chart-header": "chart-header"}>{chartHeader}</p>
        <p className="chart-count">{showRupee && <>&#8377;</>}{numberWithCommas(cartHeaderCount,fractionalDigit)}{cartHeaderValue}</p>
        {loader ?  <Loader className="loader chart-loader"
                    type="ThreeDots"
                    color="#9c1d26"
                    width={100}
                   visible={loader}
                    />
              : (data?.length>0  ?
                  <>
        <ResponsiveContainer width={"100%"}>
          <PieChart>
          <Pie
          data={filterData}
          dataKey={dataKey}
          nameKey={nameKey}
          isAnimationActive={false}
          cx="50%"
          cy="40%"
          innerRadius={70}
          outerRadius={140}
          fill="#8884d8"
          label={renderCustomizedLabel}
          paddingAngle={2}
        >
          {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
          </Pie>
          {<Tooltip content={<CustomTooltip />} />}
          </PieChart>
          </ResponsiveContainer> 
          </>: <p className="no-record-found">Record Not Found</p> )}
      </div>
  )
}


export const Legends = ({data,nameKey,dataKey, isShort=true})=> {
   
  const getLegendColor = (index) => {
    if(index > COLORS.length) return COLORS[index%COLORS.length];
     return COLORS[index];
  };
  if(isShort)
  data?.sort((a,b)=> b[dataKey]-a[dataKey]);
  return (
    <div className='chart-legends-wrapper'>
      {data?.map((e, i) => {
        return (
          <>
            <span className="legend-circle-dot" style={{ backgroundColor: getLegendColor(i) }}></span>
            {!['rejectionReason','entry_toll_plaza_id'].includes(nameKey) ?'':''}{e[nameKey]} ({(+e[dataKey]).toFixed(dataKey == "sumAmount" ? 2 : 0)})
          </>
        );
      })}
    </div>
  );
}